import React from "react";
import { Routes, Route } from "react-router-dom";
import utenteRoutes from "./routes";

import {
    Button,
    Spinner,
    Row,
    Col,
    Icon,
    UncontrolledTooltip,
  } from "design-react-kit";
import CustomHeader from "../../../../layout/components/CustomHeader";
import CustomSidebar from "../../../../layout/components/sidebar/CustomSidebar";
import PopUp from "../../popup/components/PopUp";

const UtenteLayout = (props) => {

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            return (
                <Route
                    path={prop.path}
                    element={<prop.component {...props} />}
                    key={key}
                />
            )

        })
    }

    return (
        <>
        <CustomHeader></CustomHeader>
        <div style={{display:"flex", alignItems: "flex-start"}}>
            <PopUp />
            <CustomSidebar routes={utenteRoutes} />
            <Routes>
                {
                    getRoutes(utenteRoutes)
                }
            </Routes>
        </div>
        </>
        

    )
}

export default UtenteLayout